import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Tooltip as BootstrapTooltip } from 'reactstrap';
import { bind } from '../Utils/Bind';
import { uuidv4generate } from '../Utils/UUID';
import { Loader } from './Loader';
import { Placement } from './Tooltip';

export interface IInfoTooltipProps {
    readonly className?: string;
    readonly placement?: Placement;
    readonly message?: string;
    readonly loading?: boolean;
}

@observer
export class InfoTooltip extends React.Component<IInfoTooltipProps> {
    public render() {
        return (
            <>
                <BootstrapTooltip target={this.id} isOpen={this.tooltipOpen} placement={this.props.placement}>
                    {this.props.loading && <Loader loading={this.props.loading} />}
                    {this.props.message ?? 'Info not available'}
                </BootstrapTooltip>

                <a className={this.props.className} id={this.id} onMouseEnter={this.open} onMouseLeave={this.close}>
                    {this.props.children}
                </a>
            </>
        );
    }

    @bind
    @action
    private open(event: React.MouseEvent<HTMLAnchorElement>) {
        this.tooltipOpen = true;
    }

    @bind
    @action
    private close(event: React.MouseEvent<HTMLAnchorElement>) {
        this.tooltipOpen = false;
    }

    @observable
    private tooltipOpen = false;
    private id: string = 'id-' + uuidv4generate();
}
